import Chart from './Chart';
import { Tooltip } from 'antd';
import { Info } from '@phosphor-icons/react';
import {
  BottomCard as Card,
  BottomCardHeader2,
} from './styles';

type ChartItem = {
  value: number;
};

type Props = {
  label: string;
  value: string | number;
  helpText?: string;
  data?: ChartItem[];
  fillcolor?: string;
  variation?: string;
  variationLabel?: string;
  openModal?: (value: boolean) => void;
};

export const BottomCardGraphic4 = ({
  label,
  value,
  helpText,
  data = [],
  fillcolor = '#EC6643',
  variation,
  variationLabel = 'desde último mês',
  openModal,
}: Props) => {
  return (
    <Card
      onClick={() => {
        openModal && openModal(true);
      }}
      style={{
        gap: '.5rem',
        minHeight: '110px',
        justifyContent: 'space-between',
      }}
    >
      <BottomCardHeader2>
        <span>{label}</span>
        <Tooltip title={helpText}>
          <Info size="1rem" color="#EC6643" />
        </Tooltip>
      </BottomCardHeader2>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          gap: '1rem',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '.35rem',
            flex: 1,
          }}
        >
          <strong
            style={{
              fontSize: '2rem',
              lineHeight: 1.1,
              color: '#111827',
              fontWeight: 700,
            }}
          >
            {value}
          </strong>

          {!!variation && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '.35rem',
                fontSize: '12px',
                color: '#9CA3AF',
              }}
            >
              <span
                style={{
                  color: '#FF6B6B',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                }}
              >
                ↘ {variation}
              </span>
              <span>{variationLabel}</span>
            </div>
          )}
        </div>

        <div style={{ width: '95px', minWidth: '95px' }}>
          <Chart
            data={(data || [])
              .filter((item) => !Number.isNaN(item?.value))
              .map((item) => item.value)}
            fillcolor={fillcolor}
          />
        </div>
      </div>
    </Card>
  );
};